"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Based on LinearProgess from material-ui:
 * https://github.com/callemall/material-ui
 */


var transitions = {
  easeOut: function easeOut(duration, property, delay, easeFunction) {
    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var _transitions = '';

      for (var i = 0; i < property.length; i++) {
        if (_transitions) _transitions += ',';
        _transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return _transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
  }
};

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props) {
  var max = props.max,
      min = props.min,
      value = props.value;
  var styles = {
    root: {
      position: 'relative',
      height: 8,
      display: 'block',
      width: '100%',
      backgroundColor: '#B0B0B0',
      borderRadius: 4,
      margin: 0,
      overflow: 'hidden'
    },
    bar: {
      height: '100%'
    },
    barFragment1: {},
    barFragment2: {}
  };

  if (props.mode === 'indeterminate') {
    styles.barFragment1 = {
      position: 'absolute',
      backgroundColor: props.color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: transitions.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
    };
    styles.barFragment2 = {
      position: 'absolute',
      backgroundColor: props.color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: transitions.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
    };
  } else {
    styles.bar.backgroundColor = props.color;
    styles.bar.transition = transitions.create('width', '.3s', null, 'linear');
    styles.bar.width = "".concat(getRelativeValue(value, min, max), "%");
  }

  return styles;
}

var CwLinearProgressBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CwLinearProgressBar, _Component);

  function CwLinearProgressBar() {
    (0, _classCallCheck2.default)(this, CwLinearProgressBar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwLinearProgressBar).apply(this, arguments));
  }

  (0, _createClass2.default)(CwLinearProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.timers = {};
      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
      this.timers.bar2 = setTimeout(function () {
        _this.barUpdate('bar2', 0, _this.refs.bar2, [[-200, 100], [107, -8]], 0);
      }, 850);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timers.bar1);
      clearTimeout(this.timers.bar2);
    }
  }, {
    key: "barUpdate",
    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
      var _this2 = this;

      if (this.props.mode !== 'indeterminate') return;
      timeToNextStep = timeToNextStep || 420;
      step = step || 0;
      step %= 4;
      var right = 'right';
      var left = 'left';

      if (step === 0) {
        barElement.style[left] = "".concat(stepValues[0][0], "%");
        barElement.style[right] = "".concat(stepValues[0][1], "%");
      } else if (step === 1) {
        barElement.style.transitionDuration = '840ms';
      } else if (step === 2) {
        barElement.style[left] = "".concat(stepValues[1][0], "%");
        barElement.style[right] = "".concat(stepValues[1][1], "%");
      } else if (step === 3) {
        barElement.style.transitionDuration = '0ms';
      }

      this.timers[id] = setTimeout(function () {
        return _this2.barUpdate(id, step + 1, barElement, stepValues);
      }, timeToNextStep);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["style"]);
      var styles = getStyles(this.props);
      return _react.default.createElement("div", (0, _extends2.default)({}, other, {
        style: Object.assign(styles.root, style)
      }), _react.default.createElement("div", {
        style: styles.bar
      }, _react.default.createElement("div", {
        ref: "bar1",
        style: styles.barFragment1
      }), _react.default.createElement("div", {
        ref: "bar2",
        style: styles.barFragment2
      })));
    }
  }]);
  return CwLinearProgressBar;
}(_react.Component);

CwLinearProgressBar.propTypes = {
  /**
   * The color of the progress bar, defaults to
   * primary color of theme.
   */
  color: _propTypes.default.string,

  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes.default.number,

  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes.default.number,

  /**
   * The mode of show your progress, indeterminate for when
   * there is no value for progress.
   */
  mode: _propTypes.default.oneOf(['determinate', 'indeterminate']),

  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes.default.object,

  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes.default.number
};
CwLinearProgressBar.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100,
  color: '#026CCF'
};
var _default = CwLinearProgressBar;
exports.default = _default;